
// imports
import { PropiedadesComponent } from '../propiedades/propiedades.component';
import { SolicitanteComponent } from '../solicitante/solicitante.component';
import { Tipos_certificadosComponent } from '../tipos_certificados/tipos_certificados.component';
import { CorviComponent } from '../corvi/corvi.component';
import { Resumen_certComponent } from '../resumen_cert/resumen_cert.component';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FilterPipe3 } from 'src/app/pipes/filter.pipe3';

import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,

} from '@angular/material';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2Rut } from 'ng2-rut';
import { NgxPaginationModule } from 'ngx-pagination';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Tabs_certComponent } from '../tabs_cert/tabs_cert.component';
import { PortalPagoComponent } from '../portal_pago/portal_pago.component';

// @NgModule decorator with its metadata
@NgModule({
  declarations: [
   PropiedadesComponent,
    SolicitanteComponent,
    Tipos_certificadosComponent,
    CorviComponent,
    Resumen_certComponent, 
    FilterPipe3,
    Tabs_certComponent,
    PortalPagoComponent
     ],
  imports: [
    FormsModule,
    Ng2Rut,
    NgxPaginationModule,
    CommonModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    FileUploadModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgxSpinnerModule,
    HttpClientModule
  ],

  exports: [
    PropiedadesComponent,
    SolicitanteComponent,
    Tipos_certificadosComponent,
    CorviComponent,
    Resumen_certComponent, 
    FilterPipe3,
    PortalPagoComponent,
    Tabs_certComponent  
  ]
})
export class Navbar_certModule { }